import { createContext } from 'react'

const PrivacyModalContext = createContext()

export default PrivacyModalContext
